import { render, staticRenderFns } from "./main.vue?vue&type=template&id=b4441bfe&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&lang=css&"
import style1 from "./main.vue?vue&type=style&index=1&id=b4441bfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4441bfe",
  null
  
)

component.options.__file = "main.vue"
export default component.exports